
import { QuickEditAction } from "./types";

export const GEMINI_IMAGE_GEN_MODEL = "imagen-4.0-generate-001";
export const GEMINI_VISION_MODEL = "gemini-3-flash-preview";

export const MOCK_API_KEY_INFO = "Ensure your Gemini API Key is configured in process.env.API_KEY or equivalent for backend/build.";

export const QUICK_EDIT_ACTIONS: QuickEditAction[] = [
  {
    id: "default-toonify",
    label: "Estilo Cómic",
    promptGenerator: (baseSubject: string) => `Crear una ilustración vibrante estilo cómic o dibujos animados de: ${baseSubject}. Enfatizar contornos definidos y colores planos.`,
  },
  {
    id: "default-vintage",
    label: "Foto Antigua",
    promptGenerator: (baseSubject: string) => `Transformar en una fotografía antigua, sepia: ${baseSubject}. Añadir grano de película y ligero desvanecimiento para autenticidad.`,
  },
  {
    id: "default-dreamy",
    label: "Efecto Ensueño",
    promptGenerator: (baseSubject: string) => `Reimaginar como una pintura etérea, casi surrealista y de ensueño de: ${baseSubject}. Usar enfoque suave, reflejos brillantes y una paleta de colores ligeramente desaturada.`,
  },
  {
    id: "default-sketch",
    label: "Boceto a Lápiz",
    promptGenerator: (baseSubject: string) => `Crear un boceto detallado a lápiz de: ${baseSubject}. Enfocarse en sombreado, textura y trazos como si estuviera dibujado a mano.`,
  },
  {
    id: "default-popart",
    label: "Arte Pop",
    promptGenerator: (baseSubject: string) => `Convertir a una imagen estilo Arte Pop inspirada en Andy Warhol o Roy Lichtenstein, mostrando: ${baseSubject}. Usar colores brillantes y llamativos y posiblemente patrones de puntos de semitonos.`,
  }
];

export const GENERATED_IMAGES_CATEGORY_NAME = "My AI Creations"; // Internal name
export const GENERATED_IMAGES_FASE_PATH = "Fase99"; // No trailing slash

export const EXPORTED_IMAGES_CATEGORY_NAME = "My Final Artwork"; // Internal name
export const EXPORTED_IMAGES_FASE_PATH = "Fase100"; // No trailing slash

// Spanish names for user gallery view and messages
export const USER_CREATED_WORK_SPANISH_NAME = "Mis Creaciones (AI)"; // For UI in ImageBrowser
export const USER_EXPORTED_ART_SPANISH_NAME = "Mi ArteAI Final"; // For UI in ImageBrowser

const ORIGINAL_CATEGORY_MAPPING: Record<string, string> = {
  "Encorsetadas": "Fase01",
  "Encorbatadas": "Fase02",
  "Chicas de los 50": "Fase03",
  "NeonPunk": "Fase04",
  "Chicas Manga": "Fase05",
  "ChicasFantasy": "Fase06",
  "ChicasDigital": "Fase07",
  "ChicasDibujadas": "Fase08",
};

export const CATEGORY_TO_FASE_MAPPING: Record<string, string> = {
  ...ORIGINAL_CATEGORY_MAPPING,
  [GENERATED_IMAGES_CATEGORY_NAME]: GENERATED_IMAGES_FASE_PATH,
  [EXPORTED_IMAGES_CATEGORY_NAME]: EXPORTED_IMAGES_FASE_PATH, 
};

// TOP_LEVEL_CATEGORIES for the main browser view (original S3 categories)
export const TOP_LEVEL_CATEGORIES = Object.keys(ORIGINAL_CATEGORY_MAPPING);


export const MACHINE_CODES = ["___P3", "___P2", "___N5", "___40", "___B1", "___B2"];

// Sample dates to populate the mock structure
export const SAMPLE_DATES = ["2025-05-14", "2025-04-13", "2025-03-20"];

export const IMAGE_FILE_EXTENSIONS = [".jpg", ".jpeg", ".png"];
export const DESCRIPTION_FILE_EXTENSION = ".txt";

export const FOLDER_COLORS = [
  'bg-rose-600', 'bg-pink-600', 'bg-fuchsia-600', 'bg-purple-600',
  'bg-violet-600', 'bg-indigo-600', 'bg-blue-600', 'bg-sky-600',
  'bg-cyan-600', 'bg-teal-600', 'bg-emerald-600', 'bg-green-600',
  'bg-lime-600', 'bg-yellow-600', 'bg-amber-600', 'bg-orange-600',
  'bg-red-600',
  'bg-rose-500', 'bg-pink-500', 'bg-fuchsia-500', 'bg-purple-500',
  'bg-violet-500', 'bg-indigo-500', 'bg-blue-500', 'bg-sky-500',
  'bg-cyan-500', 'bg-teal-500', 'bg-emerald-500', 'bg-green-500',
  'bg-lime-500', 'bg-yellow-500', 'bg-amber-500', 'bg-orange-500',
  'bg-red-500'
];

export const CUSTOM_FOLDERS_STORAGE_KEY = 'aiImageStudio_customFolders_v1';
